import React from 'react';
import { Box, Container, Typography, Grid, Paper, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const TheProblemSolution = ({ activeTab }) => {
  const isBusiness = activeTab === 0;

  const problem = isBusiness 
    ? "Pagas cientos de dólares al mes en suscripciones desconectadas. Tu CRM no habla con tu herramienta de scraping, tu equipo usa un chat externo y contratas talento a ciegas en plataformas costosas."
    : "Tienes que buscar clientes en frío, crear portafolios en plataformas dispersas, pagar cursos caros sin garantía de empleo y competir en un mercado saturado sin una comunidad que te respalde.";

  const solution = isBusiness
    ? "Hitpoly unifica tu operación. Extraes leads, los pasas al CRM integrado, hablas con tu equipo y contratas a profesionales ya formados en nuestra academia. Todo en un solo pago (o gratis)."
    : "Hitpoly es tu autopista al éxito. Estudias habilidades rentables, te integras en una comunidad activa, y tu perfil es visto directamente por las empresas que ya usan nuestro CRM y buscan talento como tú.";

  return (
    <Box sx={{ background: '#0B0914', py: { xs: 8, md: 12 }, position: 'relative' }}>
      <Container maxWidth="lg">
        <Box textAlign="center" mb={6}>
          <Typography variant="h3" fontWeight={800} color="#fff" mb={2}>
            El Fin del Caos {isBusiness ? 'Empresarial' : 'Profesional'}
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.7)', maxWidth: 700, mx: 'auto' }}>
            {isBusiness ? 'Deja de usar múltiples herramientas que no se comunican entre sí.' : 'Deja de depender de la suerte y plataformas de freelancers saturadas.'}
          </Typography>
        </Box>

        <Grid container spacing={4} alignItems="stretch">
          {/* El Problema */}
          <Grid item xs={12} md={6}>
            <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
              <Paper
                elevation={0}
                sx={{
                  p: 5,
                  height: '100%',
                  background: 'rgba(242, 28, 99, 0.05)',
                  border: '1px solid rgba(242, 28, 99, 0.2)',
                  borderRadius: '24px',
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                <Box sx={{ position: 'absolute', top: -20, right: -20, opacity: 0.1, color: '#F21C63' }}>
                  <CancelOutlinedIcon sx={{ fontSize: 150 }} />
                </Box>
                <Typography variant="h5" fontWeight={700} color="#F21C63" mb={3} display="flex" alignItems="center">
                  <CancelOutlinedIcon sx={{ mr: 1 }} /> La Forma Antigua
                </Typography>
                <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '1.1rem', lineHeight: 1.8 }}>
                  {problem}
                </Typography>
              </Paper>
            </motion.div>
          </Grid>

          {/* La Solución */}
          <Grid item xs={12} md={6}>
            <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}>
              <Paper
                elevation={0}
                sx={{
                  p: 5,
                  height: '100%',
                  background: 'rgba(108, 77, 226, 0.05)',
                  border: '1px solid rgba(108, 77, 226, 0.3)',
                  borderRadius: '24px',
                  position: 'relative',
                  overflow: 'hidden',
                  boxShadow: '0 10px 40px rgba(108, 77, 226, 0.15)'
                }}
              >
                <Box sx={{ position: 'absolute', top: -20, right: -20, opacity: 0.1, color: '#6C4DE2' }}>
                  <CheckCircleOutlineIcon sx={{ fontSize: 150 }} />
                </Box>
                <Typography variant="h5" fontWeight={700} color="#6C4DE2" mb={3} display="flex" alignItems="center">
                  <CheckCircleOutlineIcon sx={{ mr: 1 }} /> El Método Hitpoly
                </Typography>
                <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem', lineHeight: 1.8 }}>
                  {solution}
                </Typography>
              </Paper>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default TheProblemSolution;
